import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20geometric%20background%20with%20soft%20cream%20and%20terracotta%20gradients%2C%20flowing%20organic%20shapes%2C%20gentle%20waves%20and%20circles%2C%20inspiring%20and%20creative%20atmosphere%2C%20modern%20minimalist%20design%2C%208k%20resolution&width=1800&height=600&seq=cta-bg-home&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-600/90 to-primary-700/85"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold font-heading text-white">
          准备好开始你的创作之旅了吗？
        </h2>
        <p className="mt-4 text-white/80 text-base md:text-lg leading-relaxed">
          无论你是新手还是老手，这里都有适合你的po文网站。
          选择心仪的平台，迈出创作第一步，让你的文字被世界看见。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/all"
            className="px-8 py-3.5 bg-white text-primary-700 font-semibold rounded-lg hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
          >
            立即探索平台
          </Link>
          <Link
            to="/article/registration-and-publishing-tutorial"
            className="px-8 py-3.5 bg-white/15 hover:bg-white/25 text-white font-medium rounded-lg backdrop-blur-sm transition-all whitespace-nowrap cursor-pointer"
          >
            查看发布教程
          </Link>
        </div>
      </div>
    </section>
  );
}